import React from 'react';
import './Privacy.css'; // para separar los estilos

const Privacy: React.FC = () => {
  return (
    <div className="legal-page">
      <header className="header">
        <div className="ip-logo">
          <div className="rounded" style={{ width: '150px', margin: '0 auto' }}>
            <img src="/assets/logo_black.png" alt="logo broadcast" />
          </div>
        </div>
      </header>

      <main className="container">
        <h1 style={{ fontSize: '25px', margin: 0 }}>Políticas de Seguridad de la Información</h1>
        <h4 style={{ margin: 0 }}>Fecha de entrada en vigor: 01-01-2024</h4>

        <section className="section">
          <div className="section-title">1. Acceso y Control de Credenciales</div>
          <ol>
            <li>
              <strong>1.1.</strong> Se debe asignar un conjunto único de credenciales a cada usuario autorizado.
            </li>
            <li>
              <strong>1.2</strong> Los usuarios deben cambiar sus contraseñas regularmente y mantener la
              confidencialidad de sus credenciales.
            </li>
            <li>
              <strong>1.3</strong> Se implementará una política de bloqueo de cuenta después de 3 intentos fallidos de
              inicio de sesión.
            </li>
          </ol>
        </section>

        <section className="section">
          <div className="section-title">2. Protección de Datos y Privacidad</div>
          <ol>
            <li>
              <strong>2.1</strong> La información de los clientes y los datos recopilados se considerará confidencial y
              se protegerá de manera adecuada.
            </li>
            <li>
              <strong>2.2</strong> Se establecerán procedimientos para la recopilación, almacenamiento, procesamiento y
              eliminación segura de datos.
            </li>
            <li>
              <strong>2.3</strong> Los usuarios deben recibir capacitación sobre la importancia de la privacidad de los
              datos y la protección de la información.
            </li>
          </ol>
        </section>

        <section className="section">
          <div className="section-title">3. Monitoreo y Detección de Amenazas</div>
          <ol>
            <li>
              <strong>3.1</strong> Se implementarán constantemente soluciones de seguridad informática para monitorear
              la red y detectar posibles amenazas.
            </li>
            <li>
              <strong>3.2</strong> Se realizarán auditorías periódicas de seguridad para evaluar la eficacia de las
              medidas de seguridad.
            </li>
          </ol>
        </section>

        <section className="section">
          <div className="section-title">4. Respaldo y Recuperación de Datos</div>
          <ol>
            <li>
              <strong>4.1</strong> Se realizarán copias de seguridad regulares de los datos críticos de la empresa.
            </li>
            <li>
              <strong>4.2</strong> Se establecerá un plan de recuperación ante desastres para garantizar la continuidad
              del negocio en caso de eventos adversos.
            </li>
          </ol>
        </section>

        <section className="section">
          <div className="section-title">5. Actualizaciones y Parches de Software</div>
          <ol>
            <li>
              <strong>5.1</strong> Todos los sistemas y software utilizados en la Plataforma se actualizarán
              regularmente con los últimos parches de seguridad.
            </li>
            <li>
              <strong>5.2</strong> Se llevará un registro de las actualizaciones y parches aplicados, y se realizarán
              pruebas de seguridad posteriores.
            </li>
          </ol>
        </section>

        <section className="section">
          <div className="section-title">6. Política de Dispositivos Móviles</div>
          <ol>
            <li>
              <strong>6.1</strong> Se implementarán medidas de seguridad en dispositivos móviles que acceden a la red de
              la empresa.
            </li>
            <li>
              <strong>6.2</strong> Se requerirá la autenticación segura y la encriptación en dispositivos móviles
              utilizados para acceder a información corporativa.
            </li>
          </ol>
        </section>
      </main>

      <footer className="footer">
        <p>© 2025 IP Broadcast. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default Privacy;
